import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

const Button = ({ raised, loading, labelStyle, ...rest }) => {
  const props = { ...rest };
  if (loading) {
    props.disabled = true;
    props.icon = <CircularProgress size={28} thickness={4} />;
    props.label = null;
  }
  return raised ? (
    <RaisedButton labelStyle={{fontSize: '0.8125em', ...labelStyle}} {...props} />
  ) : (
    <FlatButton labelStyle={{fontSize: '0.8125em', ...labelStyle}} {...props} />
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/basic/Button.js